const careers = [
  {
    position: "Senior Software Engineer",
    start: "Dec 2022",
    end: "present",
    company: "Capital One",
    techs: ["Angular", "Vue.js", "AWS", "Node.js", "D3.js", "SCSS"],
  },
  {
    position: "Senior Software Engineer",
    start: "Mar 2022",
    end: "Dec 2022",
    company: "Major League Baseball",
    techs: [
      "React",
      "Redux",
      "styled-components",
      "Storybook",
      "TypeScript",
      "Webpack",
      "SCSS",
    ],
  },
  {
    position: "Software Engineer",
    start: "Nov 2018",
    end: "Mar 2022",
    company: "Major League Baseball",
  },
  {
    position: "Software Engineer",
    start: "May 2017",
    end: "Nov 2018",
    company: "The MITRE Corp.",
    techs: ["React", "SCSS", "Node.js", "Java", "Unity", "Unreal Engine", "VR"],
  },
  {
    position: "Serious Gaming Intern",
    start: "May 2016",
    end: "Aug 2016",
    company: "The MITRE Corp.",
    techs: ["Unity", "Unreal Engine", "VR"],
  },
  {
    position: "Software Engineering Intern",
    start: "Jun 2015",
    end: "Aug 2016",
    company: "Bluebeam, Inc.",
    techs: ["AngularJS", "SCSS"],
  },
  {
    position: `B.S. Computer Science + B.S. Game Design`,
    start: "Aug 2013",
    end: "May 2017",
    company: "Rensselaer Polytechnic Institute",
  },
];

export default careers;
